import { render, staticRenderFns } from "./ManualPayment.vue?vue&type=template&id=3ebd7063"
import script from "@/scripts/payment/manualPayment.js?vue&type=script&lang=js&external"
export * from "@/scripts/payment/manualPayment.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports